export default function getInitials(
  firstWord?: string | null,
  secondWord?: string | null
): string {
  if (!firstWord) return "";

  const getWordInitials = (name: string): string =>
    name
      .split(" ")
      .slice(0, 2)
      .reduce((initials, word) => initials + (word[0] || ""), "")
      .toUpperCase();

  const firstWordInitials = getWordInitials(firstWord);
  const secondWordInitials = secondWord ? getWordInitials(secondWord) : "";

  return firstWordInitials + secondWordInitials;
}
